import { SvgIcon } from '@mui/material';

const SVG = ({ fill = '#0A60B5' }) => {
  return (
    <SvgIcon
      style={{ width: '30px', height: '20px', fill }}
      viewBox="0 0 48 32"
    >
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="32"
        viewBox="0 0 48 32"
        preserveAspectRatio="xMidYMid meet"
      >
        {/* Stylized trace waveform mark for Langfuse */}
        <g fill="none" stroke={fill} strokeWidth="3" strokeLinecap="round">
          <path d="M4 16 h8 l4 -10 l6 20 l4 -14 l3 4 h11" />
        </g>
        <circle cx="42" cy="16" r="3" fill={fill} />
      </svg>
    </SvgIcon>
  );
};
export default SVG;
